import { createSelector } from 'reselect';

const userSelector = createSelector(
  (state) => state.user,
  (user) => user,
);

export const bookingActive = createSelector(
  userSelector,
  (user) => user.data.booking_active,
);

export const canChangeName = createSelector(
  userSelector,
  (user) => user.data.can_change_name,
);

export const events = createSelector(userSelector, (u) => u.events);
export const eventsLoading = createSelector(userSelector, (u) => u.isLoadingEvents);

export const bookingValid = createSelector(
  userSelector,
  (user) => user.data.booking_valid,
);

export const updateState = createSelector(
  userSelector,
  (user) => user.updateState,
);

export const errors = createSelector(
  userSelector,
  (user) => user.errors,
);

export const success = createSelector(
  userSelector,
  (user) => user.success,
);

export const uploadedKyc = createSelector(
  userSelector,
  (user) => user.uploadedKyc,
);

export const uploading = createSelector(
  userSelector,
  (user) => user.uploading,
);

export const isCompany = createSelector(
  userSelector,
  (user) => user.data.type_of_person === 'LEGAL',
);

export const isLoading = createSelector(
  userSelector,
  (user) => user.isLoading,
);

export const userData = createSelector(
  userSelector,
  (user) => user.data,
);

export const lang = createSelector(
  userData,
  (data) => data.language,
);

export const langLowerCase = createSelector(
  lang,
  (ln) => (ln ? ln.toLowerCase() : ln),
);

export const mangoUserId = createSelector(
  userData,
  (data) => data.mango_user_id,
);

export const kycStatus = createSelector(
  userData,
  (data) => data.kyc_status,
);

export const isAuth = createSelector(
  userData,
  (data) => !!Object.keys(data).length,
);

export const isStrict = createSelector(
  userData,
  (data) => data.type === 'STRICT',
);

export const isAdmin = createSelector(
  userData,
  (data) => !!data.admin,
);

export const userId = createSelector(
  userData,
  (data) => data.id,
);

export const userType = createSelector(
  userData,
  (data) => data.type,
);

export const typeOfPerson = createSelector(
  userData,
  (data) => data.type_of_person,
);

export const birthday = createSelector(
  userData,
  (data) => data.birthday,
);

export const isBankLoading = createSelector(
  userSelector,
  (data) => data.isBankLoading,
);

export const isBankUpdating = createSelector(
  userSelector,
  (data) => data.isBankUpdating,
);

export const todos = createSelector(userSelector, (d) => d.todos);

export const sessionStatus = createSelector(userSelector, (d) => d.sessionStatus);

export default userSelector;
